import React, { useEffect, useRef, useState} from "react";
import './index.scss'
import Loader from "react-loaders";
import AnimatedLetters from "../AnimatedLetters";
import emailjs from '@emailjs/browser'
import { MapContainer, TileLayer, Marker} from 'react-leaflet'

const Contact = () => {

    const [letterClass, setLetterClass] = useState('text-animate')
    const form = useRef()

    useEffect(() => {
        setTimeout(() => {
            return setLetterClass('text-animate-hover')
        }, 3000)
    }, [])

    const sendEmail = (e) => {
        e.preventDefault()

        emailjs
            .sendForm(
                'service_m4tohxq',
                'template_6xf8ot9',
                form.current,
                'Ei8fzxT2XGedW_S19'
            )
            .then(
                () => {
                    alert('Message has been sent!')
                    e.target.reset(); // Reset form fields
                },
                () => {
                    alert('Failed to send the message, please try again.')
                }
            )
    }

    return (
        <>
        <div className="container contact-page">
            <div className="text-zone">
                <h1>
                    <AnimatedLetters
                    letterClass={letterClass}
                    strArray={"Contact Me!".split("")}
                    idx={15}
                     />
                </h1>
                <p>
                    I am interested in full-stack web development roles,
                    as well as positions that either favor back-end or front-end development.
                    However, if you have other suggestions or questions, please don't hesitate
                    to reach out to me via the form below. Thank you.
                </p>
                <div className="contact-form">
                    <form ref={form} onSubmit={sendEmail}>
                        <ul>
                            <li className="half">
                                <input type='text' name='name' placeholder='Your Name' required />
                            </li>
                            <li className="half">
                                <input type='email' name='email' placeholder='Your Email' required />
                            </li>
                            <li>
                                <input type='text' name='subject' placeholder='Subject' required />
                            </li>
                            <li>
                                <textarea placeholder="Message" name="message" required></textarea>
                            </li>
                            <li>
                                <input type='submit' className="flat-button" value='SEND' />
                            </li>
                        </ul>
                    </form>
                </div>
            </div>
            <div className="info-map">
                Anton Zaitsev,
                <br />
                Miami, FL
                <br />
                <span>antonzaitsev429@gmail.com</span>
            </div>
            <div className="map-wrap">
                <MapContainer center={[25.7617, -80.1918]} zoom={13}>
                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                    <Marker position={[25.7617, -80.1918]}>
                    </Marker>
                </MapContainer>
            </div>
        </div>
        <Loader type="semi-circle-spin" />
        </>
    )
}

export default Contact
